module.exports = __webpack_public_path__ + "static/media/promo.a67c843c.png";